import {useNavigate} from 'react-router-dom';
import {showNotification} from '@mantine/notifications';
import {AiOutlineExclamation} from 'react-icons/ai';

import {EmailForm} from '../forms/EmailForm';
import {useAccounts} from '../hooks/useAccounts';
import {Account} from '../types.ts';
import {searchAccounts} from '../reducers/recordsSlice';


export const AddPage = () => {
    const navigate = useNavigate();

    const {handleSearchAccounts} = useAccounts();

    const handleSubmit = async (values: Account) => {
        const result = await handleSearchAccounts(values.email);

        if (searchAccounts.rejected.match(result)) {
            showNotification({
                title: 'Unable to add account',
                icon: <AiOutlineExclamation/>,
                message: 'Could not find or access this account. If you are signed in, try signing out first and then adding the account.',
                color: 'red',
            });
            return;
        }

        navigate('/accounts');
    };

    let initialValues = {email: ''} as Account;

    return (
        <EmailForm
            handleSubmit={handleSubmit}
            record={initialValues}
        />
    );
};
